// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */

const initNonCritical = async () => {
  // Lazy load video handling
  const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]')
  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }

  /*
    Intersecting elements helper
*/
  const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  ) as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }

  // Sticky header
  const header = document.getElementById('site-header')
  if (header) {
    import('./modules/sticky-header').then(({ initStickyHeader }) => {
      initStickyHeader()
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}

const mobileMenuWrapper = document.querySelectorAll('.mobileMenuWrapper')
if (mobileMenuWrapper && mobileMenuWrapper !== null) {
  mobileMenuWrapper.forEach((wrapper) => {
    import('./MobileMenu/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const menuButtonWrapper = document.querySelectorAll('.menuButtonWrapper')
if (menuButtonWrapper && menuButtonWrapper !== null) {
  menuButtonWrapper.forEach((wrapper) => {
    import('./MobileMenu/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const jsExpandableText = document.querySelectorAll('.js-expandable-text')
if (jsExpandableText && jsExpandableText.length > 0) {
  import('./modules/expandableText').then((module) => {
    module.default()
  })
}

const jsExpand = document.querySelectorAll('.js-expand')

if (jsExpand && jsExpand.length > 0) {
  import('./modules/project-details').then((module) => {
    module.default()
  })
}

const jsClipboard = document.querySelectorAll('.js-clipboard')

if (jsClipboard && jsClipboard.length > 0) {
  import('./modules/clipboard').then((module) => {
    module.default()
  })
}

const heroImageContainers = document.querySelectorAll('.hero-images')

if (heroImageContainers && heroImageContainers.length > 0) {
  import('./modules/hero-images').then((module) => {
    module.default()
  })
}
